import dataSelect from '@store/dataForSelect/reducers';

import { question_category_select } from '../../configs/constants';

export default dataSelect(question_category_select);
